import styled, { css, keyframes } from 'styled-components';
import { GetStarted } from '../../LandingPage/styles';
import { Select } from 'antd';

const slideUpButton = (top) => keyframes`
0% {
  transform: translateY(${top ? '40':'0'}px);
}
100% {
  transform: translateY(${top ? '0': '-40'}px);
}
`;

const slideDownBotton = (top) => keyframes`
0% {
  transform: translateY(${top ? '0': '-40'}px);
}
100% {
  transform: translateY(${top ? '40':'0'}px);
}
`;

const fadeIn = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;

const slideDown = keyframes`
0% {
  opacity: 0;
  transform: translateY(-40px);
}
100% {
  opacity: 1;
  transform: translateY(0);
}
`;

export const DisableContainer = styled.div`
  cursor: ${props => (props.disabled ? 'not-allowed' : '')};
  display: flex;
  flex-direction: column;
  margin-top:  ${props => (props.isModal ? '0px' : '50px')};
  gap: ${props => (props.isModal ? '20px' : '0px')};
`;

export const RulesTabContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  > :first-child {
    margin-left: 40px;
    align-self: flex-start;
  }
`;

export const BusinessLogicSaveButton = styled.div`
  display: flex;
  background: rgb(37, 41, 45);
  justify-content: end;
  z-index: 2;
  position: relative;
  max-width: 720px;
  div,
  span {
    cursor: pointer;
    text-transform: uppercase;
    background-color: #ff7200;
    color: white;
    padding: 5px 20px;
    font-size: 15px;
    font-weight: bold;
    margin-top: -75px;
    position: absolute;
    animation-delay: 0.8s;
    ${({ show }) => (show ? slideUpBtnAnim : slideDownBtnAnim)};
    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
    transition: all 0.8s ease-in-out;
    &.ant-spin {
      min-width: 170px;
      min-height: 35px;
    }
  }
  span {
    background-color: #039b51;
  }
`;

export const BLSaveButton = styled.div`
  display: flex;
  background: rgb(37, 41, 45);
  justify-content: end;
  z-index: 2;
  position: relative;
  max-width: 720px;
  div,
  span {
    cursor: pointer;
    text-transform: uppercase;
    background-color: #ff7200;
    color: white;
    padding: 5px 20px;
    font-size: 15px;
    font-weight: bold;
    animation-delay: 0.8s;
    ${({ show }) => css`
       pointer-events: ${show ? 'auto' : 'none'}
       opacity: ${show ? 1 : 0.5};
    `}
    transition: all 0.8s ease-in-out;
    &.ant-spin {
      min-width: 170px;
      min-height: 35px;
    }
  }
  span {
    background-color: #039b51;
  }
`;

const slideUpBtnAnim = css`
  animation: ${slideUpButton(true)} 0.8s ease-in;
`;

const slideDownBtnAnim = css`
  animation: ${slideDownBotton(true)} 0.8s ease-out;
`;

export const BusinessLogicCancelButton = styled(BusinessLogicSaveButton)`
  z-index: 1;
  span {
    background-color: #039b51;
    ${({ show }) => (show ? slideUpBtnAnim : slideDownBtnAnim)};
    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  }
`;

const slideDownAnim = css`
  animation: ${slideDown} 1s ease-in-out;
`;

const fadeInAnim = css`
  animation: ${fadeIn} 1s ease-in-out;
`;

export const BusinessLogicContainer = styled.div`
  display: flex;
  border-radius: 4px;
  pointer-events: ${props => (props.disabled ? 'none' : '')};
  ${({ show }) => (show ? slideDownAnim : '')};
  display: ${({ show }) => (show ? '' : 'none')};
  ${({ showEdit }) => (showEdit ? '' : fadeInAnim)};

  > .anticon.add-icon {
    margin-left: 20px;
    font-size: 30px;
    align-self: center;
    color: #ffffff;
    margin-top: -50px;
  }
`;

export const RuleEditingContainer = styled.div`
  background-color: ${({type}) => (type === 'element' ? '#917bf7': type === 'flow'? '#FFEB3B' : '#6ce5e7')};
  position: relative;
`;

export const BusinessLogicButton = styled(GetStarted)`
  button#add-business-logic {
    height: 50px;
    font-size: 14px;
    font-weight: normal !important;
    margin-top: 10px;
    min-width: 270px;
    width: fit-content;
    text-transform: none;
    :before {
      text-transform: none;
    }
    div {
      text-transform: none;
    }
  }
`;

export const Placeholder = styled.div`
  color: #c8c3cf;
  cursor: pointer;
`;

export const BusinessLogicHeader = styled.form`
  animation: ${fadeIn} 1s ease-in-out;
  // margin-top: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #6ce5e7;
  max-width: 720px;
  position: relative;
  z-index: 3;
  width: 720px;
  border-radius: ${props => (props.enableForm ? '4px' : '4px 4px 0px 0px')};
  pointer-events: ${props => (props.disabled ? 'none' : '')};
  input {
    background-color: #6ce5e7;
    border: none;
    margin-left: 20px;
    width: 70%;
    outline: none;
    color: black;
    box-shadow: none;
  }
  .ant-btn {
    background: #000 !important;
    border: transparent;
    color: #fff;
    margin-right: 20px;
    background-color: black;
    color: white;
    min-width: 110px;
    .anticon {
      vertical-align: middle;
    }
  }
  > div {
    color: black;

    input {
      background-color: transparent;
      border: none;
      box-shadow: none;
      outline: none;
      font-weight: bold;
      :hover,
      :active,
      :focus {
        background-color: transparent;
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
    > div {
      font-weight: bold;
      margin-left: 20px;
    }
  }
  > .anticon {
    color: black;
    margin-right: 20px;
  }
  > div.edit-delete-container {
    display: flex;
    align-items: center;
    width: 60px;
    justify-content: space-between;
    margin-right: 10px;
    > .anticon-delete {
      font-size: 20px;
    }
  }
`;

export const TableOperator = styled.div`
  display: flex;
  div.ant-select {
    min-width: 120px;
    margin: 0px 10px;
    background-color: white;

    .ant-select-selection {
      background-color: #f8f9fd;
      font-weight: normal;
      .ant-select-selection-selected-value {
        color: black;
      }
    }
    .ant-select-arrow {
      color: black !important;
    }
  }
  input {
    margin-right: 10px;
    margin-top: 5px;
    background-color: #f8f9fd;
    border: none;
    max-width: 100px;
    box-shadow: none;
    outline: none;
    &#tag-input {
      height: 32px;
      border-radius: 4px;
      padding: 4px 11px;
      width: 100%;
      &::placeholder {
        color: #cdcdce;
        font-size: 14px;
      }
    }
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selection-selected-value {
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.5;
  }
`

export const TableLogicalOperator = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-transform: capitalize;

  .ant-select-selection {
    background-color: #ffffff;
    color: #000000;
    border: none;
    margin: 0px 0px;
  }
  .ant-select-selection__rendered {
    margin-right: 0px !important;
    margin-left: 0px;
  }
`;

export const TableEditContainer = styled.div`
  min-width: 360px;
  max-width: 360px;
  overflow-x: auto;
  margin-left: 360px;
  display: ${({ show }) => (show ? '' : 'none')};

  table {
    width: 100%;
    table-layout: fixed;
    thead,
    tbody {
      tr {
        :hover {
          > div:last-of-type {
            display: block;
          }
        }
        > div:last-of-type {
          position: absolute;
          left: -12px;
          display: none;
          z-index: 1;
          fill: #ffffff;
        }
        th,
        td {
          height: 70px;
          width: 360px;
          border: 1px solid #accfe2;
          background-color: white;
          color: black;
          text-align: center;
          vertical-align: middle;
          font-size: 16px;
          div.scroll-head {
            margin-top: -34px;
            position: absolute;
            z-index: 3;
            margin-left: 120px;
          }
          span.swap-icon {
            margin-left: -10px;
            float: left;
            cursor: pointer;
            .anticon-swap {
              margin-left: 1px;
            }
          }

          div[id$='-rule-condition-select'],
          div[id$='-rule-section-name-select'] {
            min-width: 100px;
            .ant-select-selection,
            .ant-select-selection:hover,
            .ant-select-selection:focus,
            .ant-select-selection:active {
              border: none !important;
              background-color: transparent;
              box-shadow: none;
            }
          }
          div[id$='-rule-condition-select'] {
            .ant-select-selection {
              color: white;
            }
          }
          div[id$='-rule-section-name-select'] {
            .ant-select-selection {
              color: black;
            }
          }
        }
        th {
          font-weight: bold;
          :first-of-type {
            background-color: black;
            color: #e4c654;
            z-index: 2;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 360px;
            margin-left: -360px;
          }
        }
        td {
          :first-of-type {
            background: linear-gradient(
              90deg,
              rgba(81, 166, 190, 1) 0%,
              rgba(137, 136, 215, 1) 50%,
              rgba(188, 97, 246, 1) 100%
            );
            color: white;
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 360px;
            margin-left: -360px;
          }
        }
      }
      tr {
        :nth-last-child(2) {
        ${(props => props.isBlockLogic ? 
          `td {
            :first-child {
              background: none;
              background-color: black;
              color: #e4c654;
              font-weight: bold;
              > div {
                color: #e4c654;
                font-weight: bold;
              }
            }
          }` : '')}
        }
        :nth-last-child(1) {
          td {
            :first-child {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  &.table-scroll {
    min-width: 480px;
    max-width: 480px;
    margin-left: 240px;

    table {
      tbody,
      thead {
        th,
        td {
          width: 240px;
          :first-of-type {
            width: 240px;
            margin-left: -240px;
          }
        }
      }
    }
  }
`;

export const TableViewContainer = styled.div`
  min-width: 720px;
  max-width: 720px;
  display: ${({ show }) => (show ? '' : 'none')};

  table {
    width: 100%;
    table-layout: fixed;

    thead,
    tbody {
      th,
      td {
        height: 70px;
        width: 719px;
        border: 1px solid #accfe2;
        background-color: white;
        color: black;
        text-align: center;
        vertical-align: middle;
        font-size: 16px;
      }
      th {
        font-weight: bold;
      }
    }
  }
  &.table-three-colum {
    table {
      thead,
      tbody {
        th,
        td {
          width: 239px;
        }
      }
    }
  }
  &.table-two-column {
    table {
      thead,
      tbody {
        th,
        td {
          width: 359px;
        }
      }
    }
  }
`;

export const TableArrowContainer = styled.div`
  .left-arrow,
  .right-arrow {
    display: block;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    margin-top: -44px;
    cursor: pointer;
    background-color: white;
    border: 1px solid white;
    border-radius: 50%;
    opacity: 0.2;
    transition: all 0.8s ease-out;

    :hover {
      opacity: 0.8;
      transition: all 0.8s ease-in-out;
    }

    ::after {
      height: 20px;
      width: 20px;
      border-top: 2px solid #000;
      border-left: 2px solid #000;
      content: '';
      position: absolute;
    }
  }
  .left-arrow {
    ::after {
      transform: rotate(-45deg);
      left: 12px;
      top: 8px;
    }
  }
  .right-arrow {
    right: 0px;

    ::after {
      transform: rotate(135deg);
      top: 8px;
      left: 5px;
    }
  }
`;

export const BusinessLogicFooter = styled.div`
  height: 50px;
  background-color: #2c325e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  > div.new-condition {
    cursor: pointer;
    .anticon {
      font-size: 16px;
      margin-left: 10px;
      vertical-align: middle;
    }
    > span {
      vertical-align: middle;
    }
  }
  > div.predicate-truth-radio {
    margin-right: 10px;
    .ant-radio-group {
      .ant-radio-wrapper {
        color: #ffffff;
        :lang(fr), :lang(pt) {
          font-size: 13px;
        }
        :lang(es-ES) {
          font-size: 12px;
        }
        .ant-radio {
          .ant-radio-inner {
            background-color: transparent;
            border-width: 1px;
            border-radius: 3px;
            border-color: #ffffff;
            height: 20px;
            width: 20px;
            ::after {
              display: inline-block;
              transform: rotate(45deg);
              height: 10px;
              width: 6px;
              border-bottom: 1px solid #ffffff;
              border-right: 1px solid #ffffff;
              border-radius: 0px;
              top: 2px;
              left: 6px;
              color: #ffffff;
              background-color: transparent;
            }
          }
        }
        .ant-radio-checked {
          ::after {
            border-width: 0px;
          }
          .ant-radio-inner {
            ::after {
              transform: rotate(45deg);
            }
          }
        }
        span {
          :last-child {
            text-transform: uppercase;
            margin-left: 8px;
            vertical-align: text-bottom;
          }
        }
      }
    }
  }
`;

export const LogicNameWrapper = styled.div`
  width: inherit;
`;